import React from "react";
import SectionCard from "../../SectionCard";
import PositionSection from "../elementFormSection/PositionSection";
import ElementPosition from "../elementFormSection/ElementPosition";
import RotateSection from "../elementFormSection/RotateSection";
import ShowOnPageSection from "../elementFormSection/ShowOnPageSection";
import TagSection from "../elementFormSection/TagSection";
import AnimationSection from "../elementFormSection/AnimationSection";
import ClickActionSection from "../elementFormSection/ClickActionSection";
import { animationSummary, appearanceSummary, clickActionSummary, layoutSummary, metadataSummary, transformSummary } from "../elementFormSection/sectionSummaries";
import ElementSizeBlock from "../elementFormSection/ElementSizeBlock";
import { VALUE_FIELD_UI_DEFAULTS } from "../../../../../../../utils/helper";
import { faHandPointer } from "@fortawesome/free-solid-svg-icons";

const HotspotFormMockup = ({
  handleChange,
  scrollActive,
  tool,
  toolType,
  docData,
  editElement,
  setTool,
  totalPages,
  errorState,
  zoom,
  handleSubmitBtnState,
}) => (
  <div className="hs-mockup">
    <SectionCard title="Appearance" variant="appearance" defaultOpen={true} errors={[errorState?.dimensionError]} summary={appearanceSummary(tool, false)}>
      <TagSection
        handleChange={handleChange}
        tool={tool}
        totalPages={docData?.num_pages}
        setTool={setTool}
        errorState={errorState}
        toolType={toolType}
        editElement={editElement}
        docData={docData}
        handleSubmitBtnState={handleSubmitBtnState}
        mode="color-only"
      />
      <ElementSizeBlock tool={tool} handleChange={handleChange} errorState={errorState} icon={faHandPointer} presetSet="hotspot" fill={tool?.value?.bg_color || VALUE_FIELD_UI_DEFAULTS.bg_color}>
        <ElementPosition
          handleChange={handleChange}
          tool={tool}
          toolType={toolType}
          editElement={editElement}
          variant="checkbox"
        />
      </ElementSizeBlock>
    </SectionCard>

    <SectionCard title="Layout & Position" errors={[errorState?.pageErr]} summary={layoutSummary(tool, false)}>
      <PositionSection
        handleChange={handleChange}
        tool={tool}
        setTool={setTool}
        errorState={errorState}
        zoom={zoom}
        showSize={false}
      >
        {tool?.id && (
          <ShowOnPageSection
            tool={tool}
            totalPages={docData?.num_pages}
            handleChange={handleChange}
            errorState={errorState}
            inline
          />
        )}
      </PositionSection>
    </SectionCard>

    {tool?.id && (
      <SectionCard title="Transform" variant="transform" summary={transformSummary(tool)}>
        <RotateSection
          tool={tool}
          setTool={setTool}
          handleSubmitBtnState={handleSubmitBtnState}
        />
      </SectionCard>
    )}

    <SectionCard title="Animation" variant="animation" summary={animationSummary(tool)}>
      <AnimationSection
        handleChange={handleChange}
        tool={tool}
      />
    </SectionCard>

    <SectionCard title="Click Action" variant="action" errors={[errorState?.pageErr, errorState?.hrefErr, errorState?.ljErr]} summary={clickActionSummary(tool)}>
      <ClickActionSection
        totalPages={totalPages}
        handleChange={handleChange}
        scrollActive={scrollActive}
        tool={tool}
        currentDocId={docData?.doc_id}
        setTool={setTool}
        errorState={errorState}
        pdfId={docData?.id}
        toolType={toolType}
      />
    </SectionCard>

    <SectionCard title="Metadata & Tracking" variant="metadata" errors={[errorState?.tagErr]} summary={metadataSummary(tool)}>
      <TagSection
        handleChange={handleChange}
        tool={tool}
        totalPages={docData?.num_pages}
        setTool={setTool}
        errorState={errorState}
        toolType={toolType}
        editElement={editElement}
        docData={docData}
        handleSubmitBtnState={handleSubmitBtnState}
        mode="tags-only"
      />
    </SectionCard>
  </div>
);

export default HotspotFormMockup;
